import { toast } from 'react-toastify';
import Service from '../../lib/Service';
import { usersActions } from '../ActionTypes';


export const fetchUsers = () => async (dispatch) => {
  try {
    dispatch({
      type: usersActions.USERS_FETCH_START
    });

    const resData = await Service.GET({
      name: 'users',
      queryString: ''
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(res.message);
    });
    dispatch({
      type: usersActions.USERS_FETCH_SUCCESS,
      payload: resData
    });
  } catch (error) {
    dispatch({
      type: usersActions.USERS_FETCH_FAILED,
      payload: { error: error.message }
    });
  }
};

export const saveUsers = (formData) => async (dispatch) => {
  try {
    const payload = {
      ...formData
    };
    dispatch({
      type: usersActions.USERS_SAVE_START
    });
    await Service[formData.Id === '0' ? 'POST' : 'PUT']({
      name: 'users',
      payload
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(toast.error(res.message));
    });
    dispatch({
      type: usersActions.USERS_SAVE_SUCCESS
    });
    toast.success('Saved Successfully');
    setTimeout(() => { window.location.href = '/users'; }, 1000);
  } catch (error) {
    dispatch({
      type: usersActions.USERS_SAVE_FAILED,
      payload: { formError: error.message }
    });
  }
};

export const editUsers = (UsersId) => async (dispatch, getState) => {
  try {
    const { usersList } = getState().users;
    const data = usersList.find((item) => item.Id === UsersId);
    if (!data) {
      throw new Error('Something went wrong');
    }
    dispatch({
      type: usersActions.USERS_SET_FORM,
      payload: { form: data }
    });
  } catch (error) {
    toast.error(error.message);
  }
};

export const resetForm = () => (dispatch) => dispatch({ type: usersActions.USERS_RESET_FORM });

export const deleteUsers = (Id) => async (dispatch) => Service.DELETE({
  name: 'users',
  payload: { Id }
}).then((res) => {
  if (res.success) {
    dispatch(fetchUsers());
    return true;
  }
  throw new Error(res.message);
});
